export const adminImages = [
  {
    "id": "img-3D-1",
    "name": "1.webp",
    "src": "/kepek/3D/1.webp"
  },
  {
    "id": "img-3D-10",
    "name": "10.webp",
    "src": "/kepek/3D/10.webp"
  },
  {
    "id": "img-3D-11",
    "name": "11.webp",
    "src": "/kepek/3D/11.webp"
  },
  {
    "id": "img-3D-12",
    "name": "12.webp",
    "src": "/kepek/3D/12.webp"
  },
  {
    "id": "img-3D-13",
    "name": "13.webp",
    "src": "/kepek/3D/13.webp"
  },
  {
    "id": "img-3D-14",
    "name": "14.webp",
    "src": "/kepek/3D/14.webp"
  },
  {
    "id": "img-3D-15",
    "name": "15.webp",
    "src": "/kepek/3D/15.webp"
  },
  {
    "id": "img-3D-16",
    "name": "16.webp",
    "src": "/kepek/3D/16.webp"
  },
  {
    "id": "img-3D-17",
    "name": "17.webp",
    "src": "/kepek/3D/17.webp"
  },
  {
    "id": "img-3D-18",
    "name": "18.webp",
    "src": "/kepek/3D/18.webp"
  },
  {
    "id": "img-3D-19",
    "name": "19.webp",
    "src": "/kepek/3D/19.webp"
  },
  {
    "id": "img-3D-2",
    "name": "2.webp",
    "src": "/kepek/3D/2.webp"
  },
  {
    "id": "img-3D-20",
    "name": "20.webp",
    "src": "/kepek/3D/20.webp"
  },
  {
    "id": "img-3D-21",
    "name": "21.webp",
    "src": "/kepek/3D/21.webp"
  },
  {
    "id": "img-3D-22",
    "name": "22.webp",
    "src": "/kepek/3D/22.webp"
  },
  {
    "id": "img-3D-23",
    "name": "23.webp",
    "src": "/kepek/3D/23.webp"
  },
  {
    "id": "img-3D-24",
    "name": "24.webp",
    "src": "/kepek/3D/24.webp"
  },
  {
    "id": "img-3D-25",
    "name": "25.webp",
    "src": "/kepek/3D/25.webp"
  },
  {
    "id": "img-3D-26",
    "name": "26.webp",
    "src": "/kepek/3D/26.webp"
  },
  {
    "id": "img-3D-27",
    "name": "27.webp",
    "src": "/kepek/3D/27.webp"
  },
  {
    "id": "img-3D-28",
    "name": "28.webp",
    "src": "/kepek/3D/28.webp"
  },
  {
    "id": "img-3D-29",
    "name": "29.webp",
    "src": "/kepek/3D/29.webp"
  },
  {
    "id": "img-3D-3",
    "name": "3.webp",
    "src": "/kepek/3D/3.webp"
  },
  {
    "id": "img-3D-30",
    "name": "30.webp",
    "src": "/kepek/3D/30.webp"
  },
  {
    "id": "img-3D-31",
    "name": "31.webp",
    "src": "/kepek/3D/31.webp"
  },
  {
    "id": "img-3D-32",
    "name": "32.webp",
    "src": "/kepek/3D/32.webp"
  },
  {
    "id": "img-3D-33",
    "name": "33.webp",
    "src": "/kepek/3D/33.webp"
  },
  {
    "id": "img-3D-34",
    "name": "34.webp",
    "src": "/kepek/3D/34.webp"
  },
  {
    "id": "img-3D-35",
    "name": "35.webp",
    "src": "/kepek/3D/35.webp"
  },
  {
    "id": "img-3D-36",
    "name": "36.webp",
    "src": "/kepek/3D/36.webp"
  },
  {
    "id": "img-3D-37",
    "name": "37.webp",
    "src": "/kepek/3D/37.webp"
  },
  {
    "id": "img-3D-38",
    "name": "38.webp",
    "src": "/kepek/3D/38.webp"
  },
  {
    "id": "img-3D-39",
    "name": "39.webp",
    "src": "/kepek/3D/39.webp"
  },
  {
    "id": "img-3D-4",
    "name": "4.webp",
    "src": "/kepek/3D/4.webp"
  },
  {
    "id": "img-3D-40",
    "name": "40.webp",
    "src": "/kepek/3D/40.webp"
  },
  {
    "id": "img-3D-41",
    "name": "41.webp",
    "src": "/kepek/3D/41.webp"
  },
  {
    "id": "img-3D-42",
    "name": "42.webp",
    "src": "/kepek/3D/42.webp"
  },
  {
    "id": "img-3D-43",
    "name": "43.webp",
    "src": "/kepek/3D/43.webp"
  },
  {
    "id": "img-3D-44",
    "name": "44.webp",
    "src": "/kepek/3D/44.webp"
  },
  {
    "id": "img-3D-45",
    "name": "45.webp",
    "src": "/kepek/3D/45.webp"
  },
  {
    "id": "img-3D-46",
    "name": "46.webp",
    "src": "/kepek/3D/46.webp"
  },
  {
    "id": "img-3D-47",
    "name": "47.webp",
    "src": "/kepek/3D/47.webp"
  },
  {
    "id": "img-3D-48",
    "name": "48.webp",
    "src": "/kepek/3D/48.webp"
  },
  {
    "id": "img-3D-49",
    "name": "49.webp",
    "src": "/kepek/3D/49.webp"
  },
  {
    "id": "img-3D-5",
    "name": "5.webp",
    "src": "/kepek/3D/5.webp"
  },
  {
    "id": "img-3D-50",
    "name": "50.webp",
    "src": "/kepek/3D/50.webp"
  },
  {
    "id": "img-3D-51",
    "name": "51.webp",
    "src": "/kepek/3D/51.webp"
  },
  {
    "id": "img-3D-52",
    "name": "52.webp",
    "src": "/kepek/3D/52.webp"
  },
  {
    "id": "img-3D-53",
    "name": "53.webp",
    "src": "/kepek/3D/53.webp"
  },
  {
    "id": "img-3D-54",
    "name": "54.webp",
    "src": "/kepek/3D/54.webp"
  },
  {
    "id": "img-3D-55",
    "name": "55.webp",
    "src": "/kepek/3D/55.webp"
  },
  {
    "id": "img-3D-56",
    "name": "56.webp",
    "src": "/kepek/3D/56.webp"
  },
  {
    "id": "img-3D-57",
    "name": "57.webp",
    "src": "/kepek/3D/57.webp"
  },
  {
    "id": "img-3D-58",
    "name": "58.webp",
    "src": "/kepek/3D/58.webp"
  },
  {
    "id": "img-3D-59",
    "name": "59.webp",
    "src": "/kepek/3D/59.webp"
  },
  {
    "id": "img-3D-6",
    "name": "6.webp",
    "src": "/kepek/3D/6.webp"
  },
  {
    "id": "img-3D-60",
    "name": "60.webp",
    "src": "/kepek/3D/60.webp"
  },
  {
    "id": "img-3D-7",
    "name": "7.webp",
    "src": "/kepek/3D/7.webp"
  },
  {
    "id": "img-3D-8",
    "name": "8.webp",
    "src": "/kepek/3D/8.webp"
  },
  {
    "id": "img-3D-9",
    "name": "9.webp",
    "src": "/kepek/3D/9.webp"
  },
  {
    "id": "img-Kreativitás-1",
    "name": "1.webp",
    "src": "/kepek/Kreativitás/1.webp"
  },
  {
    "id": "img-Kreativitás-10",
    "name": "10.webp",
    "src": "/kepek/Kreativitás/10.webp"
  },
  {
    "id": "img-Kreativitás-11",
    "name": "11.webp",
    "src": "/kepek/Kreativitás/11.webp"
  },
  {
    "id": "img-Kreativitás-12",
    "name": "12.webp",
    "src": "/kepek/Kreativitás/12.webp"
  },
  {
    "id": "img-Kreativitás-13",
    "name": "13.webp",
    "src": "/kepek/Kreativitás/13.webp"
  },
  {
    "id": "img-Kreativitás-14",
    "name": "14.webp",
    "src": "/kepek/Kreativitás/14.webp"
  },
  {
    "id": "img-Kreativitás-15",
    "name": "15.webp",
    "src": "/kepek/Kreativitás/15.webp"
  },
  {
    "id": "img-Kreativitás-16",
    "name": "16.webp",
    "src": "/kepek/Kreativitás/16.webp"
  },
  {
    "id": "img-Kreativitás-17",
    "name": "17.webp",
    "src": "/kepek/Kreativitás/17.webp"
  },
  {
    "id": "img-Kreativitás-18",
    "name": "18.webp",
    "src": "/kepek/Kreativitás/18.webp"
  },
  {
    "id": "img-Kreativitás-19",
    "name": "19.webp",
    "src": "/kepek/Kreativitás/19.webp"
  },
  {
    "id": "img-Kreativitás-2",
    "name": "2.webp",
    "src": "/kepek/Kreativitás/2.webp"
  },
  {
    "id": "img-Kreativitás-20",
    "name": "20.webp",
    "src": "/kepek/Kreativitás/20.webp"
  },
  {
    "id": "img-Kreativitás-21",
    "name": "21.webp",
    "src": "/kepek/Kreativitás/21.webp"
  },
  {
    "id": "img-Kreativitás-22",
    "name": "22.webp",
    "src": "/kepek/Kreativitás/22.webp"
  },
  {
    "id": "img-Kreativitás-23",
    "name": "23.webp",
    "src": "/kepek/Kreativitás/23.webp"
  },
  {
    "id": "img-Kreativitás-24",
    "name": "24.webp",
    "src": "/kepek/Kreativitás/24.webp"
  },
  {
    "id": "img-Kreativitás-25",
    "name": "25.webp",
    "src": "/kepek/Kreativitás/25.webp"
  },
  {
    "id": "img-Kreativitás-26",
    "name": "26.webp",
    "src": "/kepek/Kreativitás/26.webp"
  },
  {
    "id": "img-Kreativitás-27",
    "name": "27.webp",
    "src": "/kepek/Kreativitás/27.webp"
  },
  {
    "id": "img-Kreativitás-28",
    "name": "28.webp",
    "src": "/kepek/Kreativitás/28.webp"
  },
  {
    "id": "img-Kreativitás-29",
    "name": "29.webp",
    "src": "/kepek/Kreativitás/29.webp"
  },
  {
    "id": "img-Kreativitás-3",
    "name": "3.webp",
    "src": "/kepek/Kreativitás/3.webp"
  },
  {
    "id": "img-Kreativitás-30",
    "name": "30.webp",
    "src": "/kepek/Kreativitás/30.webp"
  },
  {
    "id": "img-Kreativitás-31",
    "name": "31.webp",
    "src": "/kepek/Kreativitás/31.webp"
  },
  {
    "id": "img-Kreativitás-32",
    "name": "32.webp",
    "src": "/kepek/Kreativitás/32.webp"
  },
  {
    "id": "img-Kreativitás-33",
    "name": "33.webp",
    "src": "/kepek/Kreativitás/33.webp"
  },
  {
    "id": "img-Kreativitás-34",
    "name": "34.webp",
    "src": "/kepek/Kreativitás/34.webp"
  },
  {
    "id": "img-Kreativitás-35",
    "name": "35.webp",
    "src": "/kepek/Kreativitás/35.webp"
  },
  {
    "id": "img-Kreativitás-36",
    "name": "36.webp",
    "src": "/kepek/Kreativitás/36.webp"
  },
  {
    "id": "img-Kreativitás-37",
    "name": "37.webp",
    "src": "/kepek/Kreativitás/37.webp"
  },
  {
    "id": "img-Kreativitás-38",
    "name": "38.webp",
    "src": "/kepek/Kreativitás/38.webp"
  },
  {
    "id": "img-Kreativitás-39",
    "name": "39.webp",
    "src": "/kepek/Kreativitás/39.webp"
  },
  {
    "id": "img-Kreativitás-4",
    "name": "4.webp",
    "src": "/kepek/Kreativitás/4.webp"
  },
  {
    "id": "img-Kreativitás-40",
    "name": "40.webp",
    "src": "/kepek/Kreativitás/40.webp"
  },
  {
    "id": "img-Kreativitás-41",
    "name": "41.webp",
    "src": "/kepek/Kreativitás/41.webp"
  },
  {
    "id": "img-Kreativitás-42",
    "name": "42.webp",
    "src": "/kepek/Kreativitás/42.webp"
  },
  {
    "id": "img-Kreativitás-43",
    "name": "43.webp",
    "src": "/kepek/Kreativitás/43.webp"
  },
  {
    "id": "img-Kreativitás-44",
    "name": "44.webp",
    "src": "/kepek/Kreativitás/44.webp"
  },
  {
    "id": "img-Kreativitás-45",
    "name": "45.webp",
    "src": "/kepek/Kreativitás/45.webp"
  },
  {
    "id": "img-Kreativitás-46",
    "name": "46.webp",
    "src": "/kepek/Kreativitás/46.webp"
  },
  {
    "id": "img-Kreativitás-47",
    "name": "47.webp",
    "src": "/kepek/Kreativitás/47.webp"
  },
  {
    "id": "img-Kreativitás-48",
    "name": "48.webp",
    "src": "/kepek/Kreativitás/48.webp"
  },
  {
    "id": "img-Kreativitás-49",
    "name": "49.webp",
    "src": "/kepek/Kreativitás/49.webp"
  },
  {
    "id": "img-Kreativitás-5",
    "name": "5.webp",
    "src": "/kepek/Kreativitás/5.webp"
  },
  {
    "id": "img-Kreativitás-50",
    "name": "50.webp",
    "src": "/kepek/Kreativitás/50.webp"
  },
  {
    "id": "img-Kreativitás-6",
    "name": "6.webp",
    "src": "/kepek/Kreativitás/6.webp"
  },
  {
    "id": "img-Kreativitás-7",
    "name": "7.webp",
    "src": "/kepek/Kreativitás/7.webp"
  },
  {
    "id": "img-Kreativitás-8",
    "name": "8.webp",
    "src": "/kepek/Kreativitás/8.webp"
  },
  {
    "id": "img-Kreativitás-9",
    "name": "9.webp",
    "src": "/kepek/Kreativitás/9.webp"
  },
  {
    "id": "img-celok-1",
    "name": "1.webp",
    "src": "/kepek/celok/1.webp"
  },
  {
    "id": "img-celok-10",
    "name": "10.webp",
    "src": "/kepek/celok/10.webp"
  },
  {
    "id": "img-celok-11",
    "name": "11.webp",
    "src": "/kepek/celok/11.webp"
  },
  {
    "id": "img-celok-12",
    "name": "12.webp",
    "src": "/kepek/celok/12.webp"
  },
  {
    "id": "img-celok-13",
    "name": "13.webp",
    "src": "/kepek/celok/13.webp"
  },
  {
    "id": "img-celok-14",
    "name": "14.webp",
    "src": "/kepek/celok/14.webp"
  },
  {
    "id": "img-celok-15",
    "name": "15.webp",
    "src": "/kepek/celok/15.webp"
  },
  {
    "id": "img-celok-16",
    "name": "16.webp",
    "src": "/kepek/celok/16.webp"
  },
  {
    "id": "img-celok-17",
    "name": "17.webp",
    "src": "/kepek/celok/17.webp"
  },
  {
    "id": "img-celok-18",
    "name": "18.webp",
    "src": "/kepek/celok/18.webp"
  },
  {
    "id": "img-celok-19",
    "name": "19.webp",
    "src": "/kepek/celok/19.webp"
  },
  {
    "id": "img-celok-2",
    "name": "2.webp",
    "src": "/kepek/celok/2.webp"
  },
  {
    "id": "img-celok-20",
    "name": "20.webp",
    "src": "/kepek/celok/20.webp"
  },
  {
    "id": "img-celok-21",
    "name": "21.webp",
    "src": "/kepek/celok/21.webp"
  },
  {
    "id": "img-celok-22",
    "name": "22.webp",
    "src": "/kepek/celok/22.webp"
  },
  {
    "id": "img-celok-23",
    "name": "23.webp",
    "src": "/kepek/celok/23.webp"
  },
  {
    "id": "img-celok-24",
    "name": "24.webp",
    "src": "/kepek/celok/24.webp"
  },
  {
    "id": "img-celok-25",
    "name": "25.webp",
    "src": "/kepek/celok/25.webp"
  },
  {
    "id": "img-celok-26",
    "name": "26.webp",
    "src": "/kepek/celok/26.webp"
  },
  {
    "id": "img-celok-27",
    "name": "27.webp",
    "src": "/kepek/celok/27.webp"
  },
  {
    "id": "img-celok-28",
    "name": "28.webp",
    "src": "/kepek/celok/28.webp"
  },
  {
    "id": "img-celok-29",
    "name": "29.webp",
    "src": "/kepek/celok/29.webp"
  },
  {
    "id": "img-celok-3",
    "name": "3.webp",
    "src": "/kepek/celok/3.webp"
  },
  {
    "id": "img-celok-30",
    "name": "30.webp",
    "src": "/kepek/celok/30.webp"
  },
  {
    "id": "img-celok-31",
    "name": "31.webp",
    "src": "/kepek/celok/31.webp"
  },
  {
    "id": "img-celok-32",
    "name": "32.webp",
    "src": "/kepek/celok/32.webp"
  },
  {
    "id": "img-celok-33",
    "name": "33.webp",
    "src": "/kepek/celok/33.webp"
  },
  {
    "id": "img-celok-34",
    "name": "34.webp",
    "src": "/kepek/celok/34.webp"
  },
  {
    "id": "img-celok-35",
    "name": "35.webp",
    "src": "/kepek/celok/35.webp"
  },
  {
    "id": "img-celok-36",
    "name": "36.webp",
    "src": "/kepek/celok/36.webp"
  },
  {
    "id": "img-celok-37",
    "name": "37.webp",
    "src": "/kepek/celok/37.webp"
  },
  {
    "id": "img-celok-38",
    "name": "38.webp",
    "src": "/kepek/celok/38.webp"
  },
  {
    "id": "img-celok-39",
    "name": "39.webp",
    "src": "/kepek/celok/39.webp"
  },
  {
    "id": "img-celok-4",
    "name": "4.webp",
    "src": "/kepek/celok/4.webp"
  },
  {
    "id": "img-celok-40",
    "name": "40.webp",
    "src": "/kepek/celok/40.webp"
  },
  {
    "id": "img-celok-41",
    "name": "41.webp",
    "src": "/kepek/celok/41.webp"
  },
  {
    "id": "img-celok-42",
    "name": "42.webp",
    "src": "/kepek/celok/42.webp"
  },
  {
    "id": "img-celok-43",
    "name": "43.webp",
    "src": "/kepek/celok/43.webp"
  },
  {
    "id": "img-celok-44",
    "name": "44.webp",
    "src": "/kepek/celok/44.webp"
  },
  {
    "id": "img-celok-45",
    "name": "45.webp",
    "src": "/kepek/celok/45.webp"
  },
  {
    "id": "img-celok-46",
    "name": "46.webp",
    "src": "/kepek/celok/46.webp"
  },
  {
    "id": "img-celok-47",
    "name": "47.webp",
    "src": "/kepek/celok/47.webp"
  },
  {
    "id": "img-celok-48",
    "name": "48.webp",
    "src": "/kepek/celok/48.webp"
  },
  {
    "id": "img-celok-49",
    "name": "49.webp",
    "src": "/kepek/celok/49.webp"
  },
  {
    "id": "img-celok-5",
    "name": "5.webp",
    "src": "/kepek/celok/5.webp"
  },
  {
    "id": "img-celok-50",
    "name": "50.webp",
    "src": "/kepek/celok/50.webp"
  },
  {
    "id": "img-celok-51",
    "name": "51.webp",
    "src": "/kepek/celok/51.webp"
  },
  {
    "id": "img-celok-52",
    "name": "52.webp",
    "src": "/kepek/celok/52.webp"
  },
  {
    "id": "img-celok-53",
    "name": "53.webp",
    "src": "/kepek/celok/53.webp"
  },
  {
    "id": "img-celok-54",
    "name": "54.webp",
    "src": "/kepek/celok/54.webp"
  },
  {
    "id": "img-celok-55",
    "name": "55.webp",
    "src": "/kepek/celok/55.webp"
  },
  {
    "id": "img-celok-56",
    "name": "56.webp",
    "src": "/kepek/celok/56.webp"
  },
  {
    "id": "img-celok-57",
    "name": "57.webp",
    "src": "/kepek/celok/57.webp"
  },
  {
    "id": "img-celok-58",
    "name": "58.webp",
    "src": "/kepek/celok/58.webp"
  },
  {
    "id": "img-celok-59",
    "name": "59.webp",
    "src": "/kepek/celok/59.webp"
  },
  {
    "id": "img-celok-6",
    "name": "6.webp",
    "src": "/kepek/celok/6.webp"
  },
  {
    "id": "img-celok-60",
    "name": "60.webp",
    "src": "/kepek/celok/60.webp"
  },
  {
    "id": "img-celok-61",
    "name": "61.webp",
    "src": "/kepek/celok/61.webp"
  },
  {
    "id": "img-celok-7",
    "name": "7.webp",
    "src": "/kepek/celok/7.webp"
  },
  {
    "id": "img-celok-8",
    "name": "8.webp",
    "src": "/kepek/celok/8.webp"
  },
  {
    "id": "img-celok-9",
    "name": "9.webp",
    "src": "/kepek/celok/9.webp"
  },
  {
    "id": "img-ertekek-ertek1",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek1.webp"
  },
  {
    "id": "img-ertekek-ertek10",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek10.webp"
  },
  {
    "id": "img-ertekek-ertek11",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek11.webp"
  },
  {
    "id": "img-ertekek-ertek12",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek12.webp"
  },
  {
    "id": "img-ertekek-ertek13",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek13.webp"
  },
  {
    "id": "img-ertekek-ertek14",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek14.webp"
  },
  {
    "id": "img-ertekek-ertek15",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek15.webp"
  },
  {
    "id": "img-ertekek-ertek16",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek16.webp"
  },
  {
    "id": "img-ertekek-ertek17",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek17.webp"
  },
  {
    "id": "img-ertekek-ertek18",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek18.webp"
  },
  {
    "id": "img-ertekek-ertek19",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek19.webp"
  },
  {
    "id": "img-ertekek-ertek2",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek2.webp"
  },
  {
    "id": "img-ertekek-ertek20",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek20.webp"
  },
  {
    "id": "img-ertekek-ertek21",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek21.webp"
  },
  {
    "id": "img-ertekek-ertek22",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek22.webp"
  },
  {
    "id": "img-ertekek-ertek23",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek23.webp"
  },
  {
    "id": "img-ertekek-ertek24",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek24.webp"
  },
  {
    "id": "img-ertekek-ertek25",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek25.webp"
  },
  {
    "id": "img-ertekek-ertek26",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek26.webp"
  },
  {
    "id": "img-ertekek-ertek27",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek27.webp"
  },
  {
    "id": "img-ertekek-ertek28",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek28.webp"
  },
  {
    "id": "img-ertekek-ertek29",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek29.webp"
  },
  {
    "id": "img-ertekek-ertek3",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek3.webp"
  },
  {
    "id": "img-ertekek-ertek30",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek30.webp"
  },
  {
    "id": "img-ertekek-ertek31",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek31.webp"
  },
  {
    "id": "img-ertekek-ertek32",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek32.webp"
  },
  {
    "id": "img-ertekek-ertek33",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek33.webp"
  },
  {
    "id": "img-ertekek-ertek34",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek34.webp"
  },
  {
    "id": "img-ertekek-ertek35",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek35.webp"
  },
  {
    "id": "img-ertekek-ertek36",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek36.webp"
  },
  {
    "id": "img-ertekek-ertek37",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek37.webp"
  },
  {
    "id": "img-ertekek-ertek38",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek38.webp"
  },
  {
    "id": "img-ertekek-ertek39",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek39.webp"
  },
  {
    "id": "img-ertekek-ertek4",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek4.webp"
  },
  {
    "id": "img-ertekek-ertek40",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek40.webp"
  },
  {
    "id": "img-ertekek-ertek41",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek41.webp"
  },
  {
    "id": "img-ertekek-ertek42",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek42.webp"
  },
  {
    "id": "img-ertekek-ertek43",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek43.webp"
  },
  {
    "id": "img-ertekek-ertek44",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek44.webp"
  },
  {
    "id": "img-ertekek-ertek45",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek45.webp"
  },
  {
    "id": "img-ertekek-ertek46",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek46.webp"
  },
  {
    "id": "img-ertekek-ertek47",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek47.webp"
  },
  {
    "id": "img-ertekek-ertek48",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek48.webp"
  },
  {
    "id": "img-ertekek-ertek49",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek49.webp"
  },
  {
    "id": "img-ertekek-ertek5",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek5.webp"
  },
  {
    "id": "img-ertekek-ertek50",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek50.webp"
  },
  {
    "id": "img-ertekek-ertek6",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek6.webp"
  },
  {
    "id": "img-ertekek-ertek7",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek7.webp"
  },
  {
    "id": "img-ertekek-ertek8",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek8.webp"
  },
  {
    "id": "img-ertekek-ertek9",
    "name": "Ertek",
    "src": "/kepek/ertekek/ertek9.webp"
  },
  {
    "id": "img-erzelmek-1",
    "name": "1.webp",
    "src": "/kepek/erzelmek/1.webp"
  },
  {
    "id": "img-erzelmek-10",
    "name": "10.webp",
    "src": "/kepek/erzelmek/10.webp"
  },
  {
    "id": "img-erzelmek-11",
    "name": "11.webp",
    "src": "/kepek/erzelmek/11.webp"
  },
  {
    "id": "img-erzelmek-12",
    "name": "12.webp",
    "src": "/kepek/erzelmek/12.webp"
  },
  {
    "id": "img-erzelmek-13",
    "name": "13.webp",
    "src": "/kepek/erzelmek/13.webp"
  },
  {
    "id": "img-erzelmek-14",
    "name": "14.webp",
    "src": "/kepek/erzelmek/14.webp"
  },
  {
    "id": "img-erzelmek-15",
    "name": "15.webp",
    "src": "/kepek/erzelmek/15.webp"
  },
  {
    "id": "img-erzelmek-16",
    "name": "16.webp",
    "src": "/kepek/erzelmek/16.webp"
  },
  {
    "id": "img-erzelmek-17",
    "name": "17.webp",
    "src": "/kepek/erzelmek/17.webp"
  },
  {
    "id": "img-erzelmek-18",
    "name": "18.webp",
    "src": "/kepek/erzelmek/18.webp"
  },
  {
    "id": "img-erzelmek-19",
    "name": "19.webp",
    "src": "/kepek/erzelmek/19.webp"
  },
  {
    "id": "img-erzelmek-2",
    "name": "2.webp",
    "src": "/kepek/erzelmek/2.webp"
  },
  {
    "id": "img-erzelmek-20",
    "name": "20.webp",
    "src": "/kepek/erzelmek/20.webp"
  },
  {
    "id": "img-erzelmek-21",
    "name": "21.webp",
    "src": "/kepek/erzelmek/21.webp"
  },
  {
    "id": "img-erzelmek-22",
    "name": "22.webp",
    "src": "/kepek/erzelmek/22.webp"
  },
  {
    "id": "img-erzelmek-23",
    "name": "23.webp",
    "src": "/kepek/erzelmek/23.webp"
  },
  {
    "id": "img-erzelmek-24",
    "name": "24.webp",
    "src": "/kepek/erzelmek/24.webp"
  },
  {
    "id": "img-erzelmek-25",
    "name": "25.webp",
    "src": "/kepek/erzelmek/25.webp"
  },
  {
    "id": "img-erzelmek-26",
    "name": "26.webp",
    "src": "/kepek/erzelmek/26.webp"
  },
  {
    "id": "img-erzelmek-27",
    "name": "27.webp",
    "src": "/kepek/erzelmek/27.webp"
  },
  {
    "id": "img-erzelmek-28",
    "name": "28.webp",
    "src": "/kepek/erzelmek/28.webp"
  },
  {
    "id": "img-erzelmek-29",
    "name": "29.webp",
    "src": "/kepek/erzelmek/29.webp"
  },
  {
    "id": "img-erzelmek-3",
    "name": "3.webp",
    "src": "/kepek/erzelmek/3.webp"
  },
  {
    "id": "img-erzelmek-30",
    "name": "30.webp",
    "src": "/kepek/erzelmek/30.webp"
  },
  {
    "id": "img-erzelmek-31",
    "name": "31.webp",
    "src": "/kepek/erzelmek/31.webp"
  },
  {
    "id": "img-erzelmek-32",
    "name": "32.webp",
    "src": "/kepek/erzelmek/32.webp"
  },
  {
    "id": "img-erzelmek-33",
    "name": "33.webp",
    "src": "/kepek/erzelmek/33.webp"
  },
  {
    "id": "img-erzelmek-34",
    "name": "34.webp",
    "src": "/kepek/erzelmek/34.webp"
  },
  {
    "id": "img-erzelmek-35",
    "name": "35.webp",
    "src": "/kepek/erzelmek/35.webp"
  },
  {
    "id": "img-erzelmek-36",
    "name": "36.webp",
    "src": "/kepek/erzelmek/36.webp"
  },
  {
    "id": "img-erzelmek-37",
    "name": "37.webp",
    "src": "/kepek/erzelmek/37.webp"
  },
  {
    "id": "img-erzelmek-38",
    "name": "38.webp",
    "src": "/kepek/erzelmek/38.webp"
  },
  {
    "id": "img-erzelmek-39",
    "name": "39.webp",
    "src": "/kepek/erzelmek/39.webp"
  },
  {
    "id": "img-erzelmek-4",
    "name": "4.webp",
    "src": "/kepek/erzelmek/4.webp"
  },
  {
    "id": "img-erzelmek-40",
    "name": "40.webp",
    "src": "/kepek/erzelmek/40.webp"
  },
  {
    "id": "img-erzelmek-41",
    "name": "41.webp",
    "src": "/kepek/erzelmek/41.webp"
  },
  {
    "id": "img-erzelmek-42",
    "name": "42.webp",
    "src": "/kepek/erzelmek/42.webp"
  },
  {
    "id": "img-erzelmek-43",
    "name": "43.webp",
    "src": "/kepek/erzelmek/43.webp"
  },
  {
    "id": "img-erzelmek-44",
    "name": "44.webp",
    "src": "/kepek/erzelmek/44.webp"
  },
  {
    "id": "img-erzelmek-45",
    "name": "45.webp",
    "src": "/kepek/erzelmek/45.webp"
  },
  {
    "id": "img-erzelmek-46",
    "name": "46.webp",
    "src": "/kepek/erzelmek/46.webp"
  },
  {
    "id": "img-erzelmek-47",
    "name": "47.webp",
    "src": "/kepek/erzelmek/47.webp"
  },
  {
    "id": "img-erzelmek-48",
    "name": "48.webp",
    "src": "/kepek/erzelmek/48.webp"
  },
  {
    "id": "img-erzelmek-49",
    "name": "49.webp",
    "src": "/kepek/erzelmek/49.webp"
  },
  {
    "id": "img-erzelmek-5",
    "name": "5.webp",
    "src": "/kepek/erzelmek/5.webp"
  },
  {
    "id": "img-erzelmek-50",
    "name": "50.webp",
    "src": "/kepek/erzelmek/50.webp"
  },
  {
    "id": "img-erzelmek-51",
    "name": "51.webp",
    "src": "/kepek/erzelmek/51.webp"
  },
  {
    "id": "img-erzelmek-52",
    "name": "52.webp",
    "src": "/kepek/erzelmek/52.webp"
  },
  {
    "id": "img-erzelmek-53",
    "name": "53.webp",
    "src": "/kepek/erzelmek/53.webp"
  },
  {
    "id": "img-erzelmek-54",
    "name": "54.webp",
    "src": "/kepek/erzelmek/54.webp"
  },
  {
    "id": "img-erzelmek-55",
    "name": "55.webp",
    "src": "/kepek/erzelmek/55.webp"
  },
  {
    "id": "img-erzelmek-56",
    "name": "56.webp",
    "src": "/kepek/erzelmek/56.webp"
  },
  {
    "id": "img-erzelmek-57",
    "name": "57.webp",
    "src": "/kepek/erzelmek/57.webp"
  },
  {
    "id": "img-erzelmek-58",
    "name": "58.webp",
    "src": "/kepek/erzelmek/58.webp"
  },
  {
    "id": "img-erzelmek-59",
    "name": "59.webp",
    "src": "/kepek/erzelmek/59.webp"
  },
  {
    "id": "img-erzelmek-6",
    "name": "6.webp",
    "src": "/kepek/erzelmek/6.webp"
  },
  {
    "id": "img-erzelmek-60",
    "name": "60.webp",
    "src": "/kepek/erzelmek/60.webp"
  },
  {
    "id": "img-erzelmek-61",
    "name": "61.webp",
    "src": "/kepek/erzelmek/61.webp"
  },
  {
    "id": "img-erzelmek-62",
    "name": "62.webp",
    "src": "/kepek/erzelmek/62.webp"
  },
  {
    "id": "img-erzelmek-63",
    "name": "63.webp",
    "src": "/kepek/erzelmek/63.webp"
  },
  {
    "id": "img-erzelmek-64",
    "name": "64.webp",
    "src": "/kepek/erzelmek/64.webp"
  },
  {
    "id": "img-erzelmek-7",
    "name": "7.webp",
    "src": "/kepek/erzelmek/7.webp"
  },
  {
    "id": "img-erzelmek-8",
    "name": "8.webp",
    "src": "/kepek/erzelmek/8.webp"
  },
  {
    "id": "img-erzelmek-9",
    "name": "9.webp",
    "src": "/kepek/erzelmek/9.webp"
  },
  {
    "id": "img-ido-1",
    "name": "1.webp",
    "src": "/kepek/ido/1.webp"
  },
  {
    "id": "img-ido-10",
    "name": "10.webp",
    "src": "/kepek/ido/10.webp"
  },
  {
    "id": "img-ido-11",
    "name": "11.webp",
    "src": "/kepek/ido/11.webp"
  },
  {
    "id": "img-ido-12",
    "name": "12.webp",
    "src": "/kepek/ido/12.webp"
  },
  {
    "id": "img-ido-13",
    "name": "13.webp",
    "src": "/kepek/ido/13.webp"
  },
  {
    "id": "img-ido-14",
    "name": "14.webp",
    "src": "/kepek/ido/14.webp"
  },
  {
    "id": "img-ido-15",
    "name": "15.webp",
    "src": "/kepek/ido/15.webp"
  },
  {
    "id": "img-ido-16",
    "name": "16.webp",
    "src": "/kepek/ido/16.webp"
  },
  {
    "id": "img-ido-17",
    "name": "17.webp",
    "src": "/kepek/ido/17.webp"
  },
  {
    "id": "img-ido-18",
    "name": "18.webp",
    "src": "/kepek/ido/18.webp"
  },
  {
    "id": "img-ido-19",
    "name": "19.webp",
    "src": "/kepek/ido/19.webp"
  },
  {
    "id": "img-ido-2",
    "name": "2.webp",
    "src": "/kepek/ido/2.webp"
  },
  {
    "id": "img-ido-20",
    "name": "20.webp",
    "src": "/kepek/ido/20.webp"
  },
  {
    "id": "img-ido-21",
    "name": "21.webp",
    "src": "/kepek/ido/21.webp"
  },
  {
    "id": "img-ido-22",
    "name": "22.webp",
    "src": "/kepek/ido/22.webp"
  },
  {
    "id": "img-ido-23",
    "name": "23.webp",
    "src": "/kepek/ido/23.webp"
  },
  {
    "id": "img-ido-24",
    "name": "24.webp",
    "src": "/kepek/ido/24.webp"
  },
  {
    "id": "img-ido-25",
    "name": "25.webp",
    "src": "/kepek/ido/25.webp"
  },
  {
    "id": "img-ido-26",
    "name": "26.webp",
    "src": "/kepek/ido/26.webp"
  },
  {
    "id": "img-ido-27",
    "name": "27.webp",
    "src": "/kepek/ido/27.webp"
  },
  {
    "id": "img-ido-28",
    "name": "28.webp",
    "src": "/kepek/ido/28.webp"
  },
  {
    "id": "img-ido-29",
    "name": "29.webp",
    "src": "/kepek/ido/29.webp"
  },
  {
    "id": "img-ido-3",
    "name": "3.webp",
    "src": "/kepek/ido/3.webp"
  },
  {
    "id": "img-ido-30",
    "name": "30.webp",
    "src": "/kepek/ido/30.webp"
  },
  {
    "id": "img-ido-31",
    "name": "31.webp",
    "src": "/kepek/ido/31.webp"
  },
  {
    "id": "img-ido-32",
    "name": "32.webp",
    "src": "/kepek/ido/32.webp"
  },
  {
    "id": "img-ido-33",
    "name": "33.webp",
    "src": "/kepek/ido/33.webp"
  },
  {
    "id": "img-ido-34",
    "name": "34.webp",
    "src": "/kepek/ido/34.webp"
  },
  {
    "id": "img-ido-35",
    "name": "35.webp",
    "src": "/kepek/ido/35.webp"
  },
  {
    "id": "img-ido-36",
    "name": "36.webp",
    "src": "/kepek/ido/36.webp"
  },
  {
    "id": "img-ido-37",
    "name": "37.webp",
    "src": "/kepek/ido/37.webp"
  },
  {
    "id": "img-ido-38",
    "name": "38.webp",
    "src": "/kepek/ido/38.webp"
  },
  {
    "id": "img-ido-39",
    "name": "39.webp",
    "src": "/kepek/ido/39.webp"
  },
  {
    "id": "img-ido-4",
    "name": "4.webp",
    "src": "/kepek/ido/4.webp"
  },
  {
    "id": "img-ido-40",
    "name": "40.webp",
    "src": "/kepek/ido/40.webp"
  },
  {
    "id": "img-ido-41",
    "name": "41.webp",
    "src": "/kepek/ido/41.webp"
  },
  {
    "id": "img-ido-42",
    "name": "42.webp",
    "src": "/kepek/ido/42.webp"
  },
  {
    "id": "img-ido-43",
    "name": "43.webp",
    "src": "/kepek/ido/43.webp"
  },
  {
    "id": "img-ido-44",
    "name": "44.webp",
    "src": "/kepek/ido/44.webp"
  },
  {
    "id": "img-ido-45",
    "name": "45.webp",
    "src": "/kepek/ido/45.webp"
  },
  {
    "id": "img-ido-46",
    "name": "46.webp",
    "src": "/kepek/ido/46.webp"
  },
  {
    "id": "img-ido-47",
    "name": "47.webp",
    "src": "/kepek/ido/47.webp"
  },
  {
    "id": "img-ido-48",
    "name": "48.webp",
    "src": "/kepek/ido/48.webp"
  },
  {
    "id": "img-ido-49",
    "name": "49.webp",
    "src": "/kepek/ido/49.webp"
  },
  {
    "id": "img-ido-5",
    "name": "5.webp",
    "src": "/kepek/ido/5.webp"
  },
  {
    "id": "img-ido-50",
    "name": "50.webp",
    "src": "/kepek/ido/50.webp"
  },
  {
    "id": "img-ido-51",
    "name": "51.webp",
    "src": "/kepek/ido/51.webp"
  },
  {
    "id": "img-ido-52",
    "name": "52.webp",
    "src": "/kepek/ido/52.webp"
  },
  {
    "id": "img-ido-53",
    "name": "53.webp",
    "src": "/kepek/ido/53.webp"
  },
  {
    "id": "img-ido-54",
    "name": "54.webp",
    "src": "/kepek/ido/54.webp"
  },
  {
    "id": "img-ido-55",
    "name": "55.webp",
    "src": "/kepek/ido/55.webp"
  },
  {
    "id": "img-ido-56",
    "name": "56.webp",
    "src": "/kepek/ido/56.webp"
  },
  {
    "id": "img-ido-57",
    "name": "57.webp",
    "src": "/kepek/ido/57.webp"
  },
  {
    "id": "img-ido-6",
    "name": "6.webp",
    "src": "/kepek/ido/6.webp"
  },
  {
    "id": "img-ido-7",
    "name": "7.webp",
    "src": "/kepek/ido/7.webp"
  },
  {
    "id": "img-ido-8",
    "name": "8.webp",
    "src": "/kepek/ido/8.webp"
  },
  {
    "id": "img-ido-9",
    "name": "9.webp",
    "src": "/kepek/ido/9.webp"
  }
];
